<template>
    <div class="box-container">
        <div class="box-container-header">
            <h2 class="box-title">
                {{ $t('DASHBOARD.TITLE.REGION') }}<!--지역별 검사 상태-->
                <button type="button" class="buttons-icon" data-type="ghost" data-size="xs" data-icon="info" data-trigger="tooltip" :title="$t('DASHBOARD.REGION.TOOLTIP')">info</button>
            </h2>

            <div class="actions">
                <div class="segmented-control">
                    <input type="radio" id="type01" name="type" @change="changeType('map')" :checked="selTab == 'map'">
                    <label for="type01" data-icon="map">{{$t('DASHBOARD.REGION.FORM_OF_GUIDANCE')}}</label>

                    <input type="radio" id="type02" name="type" @change="changeType('table')" :checked="selTab == 'table'">
                    <label for="type02" data-icon="list">{{$t('DASHBOARD.REGION.LIST_FORM')}}</label>
                </div>

                <dashboard-widget v-bind:type="'region'"></dashboard-widget>
            </div>
        </div>



        <nav class="navigation-tab" data-size="s">
            <h2 class="title">Product TAB</h2>
            <button v-for="(item) in inUseVendors" :key="item.CLOUD_VNDR_ID"
                type="button"
                class="tab-item"
                :class="[item.CLOUD_VNDR_ID === selectedVendor ? 'selected' : null ]"
                @click="selectVendor(item.CLOUD_VNDR_ID)"
            >
                {{ Common.getShortName(item.CLOUD_VNDR_ID) }}
            </button>
        </nav>
        <div v-show="selTab == 'table'" class="chart121212" style="height: 315px;">
            <div class="tbl-collapse" data-type-summary data-linkable-row>
                <div class="thead pl-3">
                    <div class="row">
                        <span class="cell" data-size="auto">
                            <span class="ellipsis" :title="$t('DASHBOARD.REGION.HEADER.REGION')">
                                {{ $t('DASHBOARD.REGION.HEADER.REGION') }}<!--지역-->
                            </span>
                        </span>
                        <span class="cell" data-size="count-fit" data-align="center">
                            <span class="ellipsis" :title="$t('DASHBOARD.REGION.HEADER.NUMBER_OF_POLICIES')">
                                {{ $t('DASHBOARD.REGION.HEADER.NUMBER_OF_POLICIES') }}<!--전체 정책 수-->
                            </span>
                        </span>
                        <span class="cell" data-size="status02" data-align="center">
                            <span class="ellipsis" :title="$t('DASHBOARD.REGION.HEADER.NUMBER_OF_RULES')">
                                {{ $t('DASHBOARD.REGION.HEADER.NUMBER_OF_RULES') }}<!--정책에 속한 규칙 수-->
                            </span>
                        </span>
                        <span class="cell" data-size="count-fit" data-align="center">
                            <span class="ellipsis" :title=" $t('LABEL.PASSED_RULES')">
                                {{ $t('LABEL.PASSED_RULES') }}<!--성공한 규칙-->
                            </span>
                        </span>
                        <span class="cell" data-size="count-fit" data-align="center">
                            <span class="ellipsis" :title="$t('LABEL.FAILED_RULES')">
                                {{ $t('LABEL.FAILED_RULES') }}<!--실패한 규칙-->
                            </span>
                        </span>
                        <span class="cell" data-size="" data-align="center"></span>
                    </div>

                </div>
                <div-loading v-if="pending"></div-loading>
                <div v-else class="tbody" style="height: 276px; overflow-y: auto;">
                    <div class="row" v-for="(param, index) in keySet" :key="index">
                        <div class="cells pl-3">
                            <span class="cell" data-size="auto"><span class="ellipsis" :title="$t('COMMON.REGION.'+param)">{{$t('COMMON.REGION.'+param)}}</span></span>
                            <span class="cell" data-size="count-fit" data-align="center">{{getPolicyCount(param)}}</span>
                            <span class="cell" data-size="status02" data-align="center">{{getRuleCount(param)}}</span>
                            <span class="cell" data-size="count-fit" data-align="center">{{getPassCount(param)}}</span>
                            <span class="cell" data-size="count-fit" data-align="center">{{getFailCount(param)}}</span>
                            <span class="cell" data-align="center">
<!--                            클릭 시, 컴플라이언스로 이동해서 리전별 filter 적용한 목록표시 (일단 기능이 없으니 막음)-->
                                <!--                            <span class="icon-detail-disclosure"></span>-->
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="selTab == 'map'" class="chart chart-wrapper map" style="height: 315px; overflow:hidden;">
            <div id="chartdivMap"></div>
            <div class="global-marker" id="global-marker">
                <p class="marker" data-state="pass">{{ $t('COMMON.REGION.global') }}</p>
            </div>
        </div>
    </div>

</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import DashboardWidget from "./dashboardWidget.vue";
import {mapGetters} from "vuex";

export default {
    name: 'DashboardRegion',
    props: {
        filterData: Object,
        accountList: Array,
        selectedAccounts: Array,
        inUseVendors: Array,
    },
    components: {
        DashboardWidget
    },
    data: function () {
        return {
            failPassResultList: [],
            keySet: '',
            pending: false,
            selTab: 'map',
            disableAZURE : true,
            disableAWS: true,
            disableGCP: true,
            imageSeriesMap: null,
            chartMap: null,
            chartData: [],
            resDataList: [],
            cmplAccList: [],
            rgnInfo: [],
            VENDOR: this.constants.VENDOR,
            selectedVendor: "",
        }
    },
    created: function () {
        this.selectFailPassResultList();
    },
    watch: {
        curCmpnId: function () {
            this.selectFailPassResultList();
        },
        getLocale: function () {
            this.initView()
        },
        inUseVendors(value) {
            if (value.length > 0) {
                this.selectedVendor = value[0].CLOUD_VNDR_ID;
            }
        }
    },
    computed: {
        ...mapGetters({
            curCmpnId: 'user/curCmpnId'
        }),
        getLocale: function () {
            return this.$i18n.locale;
        }
    },
    methods: {
        selectVendor(id) {
            this.pending = true
            this.selectedVendor = id;
            this.applyFilterRawData();
        },
        selectFailPassResultList: function () {
            var url = `/api/governance/dashboard/status/rgn`
            var header = {
                'cmpnId': this.curCmpnId
            }

            this.pending = true

            this.http.post(url, header)
                .then(result => {
                    
                    if (result.data != null && result.data.resultList != null) {
                        this.rgnInfo = _.cloneDeep(result.data.rgnInfo);
                        this.resDataList = _.cloneDeep(result.data.resultList);
                        this.cmplAccList = _.cloneDeep(result.data.cmplList);
                        this.applyFilterRawData();
                    }
                    this.$nextTick(function () {
                        this.initView();
                    })
                })
        },
        applyFilterRawData: function () {
            let self = this;
            let data = _.cloneDeep(this.cmplAccList);
            // account filter 적용
            if (this.filter != null && this.filter.acnt != null && typeof (this.filter.acnt) !== 'undefined' && this.filter.acnt.length > 0) {
                data = _.filter(data, function (o) {
                    let isInclude = false;
                    for (let acnt of self.filter.acnt) {
                        isInclude = _.includes(o.accId, acnt);
                        if (isInclude) break;
                    }

                    return isInclude;
                });
            }
            const selectByVendor =_.filter(self.accountList,t=>{
                   return (t.vendor == 'azure'? 'azu':t.vendor) == self.selectedVendor;
            }).map(t=>t.key);

            data = _.filter(data,t=>{
               return _.includes(selectByVendor,t.accId)
            })
            this.makeRgnDataSet(data);
        },
        makeRgnDataSet: function (cmplAccList) {
            this.pending = false;
            let filteredData = _.filter(this.resDataList, function (o) {
                let isInclude = false;
                for (let cmplAcc of cmplAccList) {
                    isInclude = _.includes(o.cmplId, cmplAcc.cmplId);
                    if (isInclude) break;
                }

                return isInclude;
            });

            let self = this;
            let failRgnMap = {};
            let passRgnMap = {};
            let plcyMap = {};
            let ruleMap = {};

            let rgnBySelectedVendor = self.rgnInfo.filter(item => item.cloudVndrId === self.selectedVendor).map(item => item.rgnId);
            if (self.selectedVendor != 'aws') {
                rgnBySelectedVendor.push('global');
            }

            _.forEach(filteredData, function (resData) {
                var plcy = resData.plcyId;
                var rule = resData.ruleId;
                if (resData.rgnYn == 'Y') {
                    if (resData.cmplRsltSc != null && resData.cmplRsltSc.length > 1) {
                        let js = JSON.parse(resData.cmplRsltSc);
                        let keySet = Object.keys(js);
                        self.filterByKeySet(keySet, js, passRgnMap, plcyMap, ruleMap, plcy, rule, rgnBySelectedVendor)
                    }
                    if (resData.cmplRsltExp != null && resData.cmplRsltExp.length > 1) {
                        let js = JSON.parse(resData.cmplRsltExp);
                        let keySet = Object.keys(js);
                        self.filterByKeySet(keySet, js, failRgnMap, plcyMap, ruleMap, plcy, rule, rgnBySelectedVendor)
                    }
                } else {
                    if (resData.cmplRslt == 'P') {
                        self.setGlobalRgnData(passRgnMap, plcyMap, ruleMap, 'global', plcy, rule)
                    } else {
                        self.setGlobalRgnData(failRgnMap, plcyMap, ruleMap, 'global', plcy, rule)
                    }
                }
            });

            // console.log(failRgnMap)
            // console.log(passRgnMap)
            // console.log(plcyMap)

            this.failPassResultList = [];
            this.failPassResultList.failRgnMap = failRgnMap;
            this.failPassResultList.passRgnMap = passRgnMap;
            this.failPassResultList.plcyMap = plcyMap;
            this.failPassResultList.ruleMap = ruleMap;
            this.failPassResultList.rgnInfo = this.rgnInfo;
            //console.log(this.failPassResultList)

            if (this.failPassResultList.plcyMap) {
                this.keySet = Object.keys(this.failPassResultList.plcyMap);
                if (this.selTab == 'map') {
                    this.makeChartData(this.failPassResultList);
                }
            }
        },
        setGlobalRgnData: function (rgnMap, plcyMap, ruleMap, rgn, plcy, rule) {
            if (_.hasIn(rgnMap, rgn)) {
                let i = rgnMap[rgn] + 1;
                rgnMap[rgn] = i;
            } else {
                rgnMap[rgn] = 1;
            }

            if (_.hasIn(plcyMap, rgn)) {
                if (_.indexOf(plcyMap[rgn], plcy) == -1) {
                    plcyMap[rgn].push(plcy)
                }
            } else {
                plcyMap[rgn] = []
                plcyMap[rgn].push(plcy)
            }

            if (_.hasIn(ruleMap, rgn)) {
                if (_.indexOf(ruleMap[rgn], rule) == -1) {
                    ruleMap[rgn].push(rule)
                }
            } else {
                ruleMap[rgn] = []
                ruleMap[rgn].push(rule);
            }
        },
        filterByKeySet: function (keySet, ruleArray, rgnMap, plcyMap, ruleMap, plcy, rule, rgnBySelectedVendor) {
            for (var key of keySet) {
                if (!(key == "condCnt" || key == "accCnt" || key == "conjunction")) {
                    if (_.isArray(ruleArray[key])) {
                        let jsonArray = ruleArray[key];
                        for (let rgn of jsonArray) {
                            if (!_.includes(rgnBySelectedVendor, rgn)) {
                                break;
                            }
                            if (_.hasIn(rgnMap, rgn)) {
                                let i = rgnMap[rgn] + 1;
                                rgnMap[rgn] = i;
                            } else {
                                rgnMap[rgn] = 1;
                            }

                            if (_.hasIn(plcyMap, rgn)) {
                                if (_.indexOf(plcyMap[rgn], plcy) == -1) {
                                    plcyMap[rgn].push(plcy)
                                }
                            } else {
                                plcyMap[rgn] = []
                                plcyMap[rgn].push(plcy)
                            }

                            if (_.hasIn(ruleMap, rgn)) {
                                if (_.indexOf(ruleMap[rgn], rule) == -1) {
                                    ruleMap[rgn].push(rule)
                                }
                            } else {
                                ruleMap[rgn] = []
                                ruleMap[rgn].push(rule);
                            }
                        }
                    } else {
                        let jsonArray = ruleArray[key];
                        this.filterByKeySet(Object.keys(jsonArray), jsonArray, rgnMap, plcyMap, ruleMap, plcy, rule, rgnBySelectedVendor)
                    }
                }
            }

        },
        isContainAccId: function (cmplAccList, cmplId) {
            for (var cmpl of cmplAccList) {
                if (cmpl.cmplId === cmplId) {
                    return true;
                }
            }
            return false;
        },
        makeChartData(rawData) {
            this.chartData = [];
            let keyList = _.cloneDeep(this.keySet);
            keyList.push('global');
            let globalTooltip = {};
            for (let param of keyList) {
                if (_.findIndex(rawData.rgnInfo, {rgnId: param}) > -1) {
                    let obj = _.find(rawData.rgnInfo, {rgnId: param})
                    obj.plcyCnt = this.getPolicyCount(param);
                    obj.ruleCnt = this.getRuleCount(param);
                    obj.failCnt = this.getFailCount(param);
                    obj.sucsCnt = this.getPassCount(param);
                    if (obj.ruleCnt == obj.sucsCnt) {
                        obj.pass = true;
                    }

                    this.chartData.push(obj);
                }
                if (param == 'global') {
                    globalTooltip.cloudVndrId = "aws";
                    globalTooltip.dflYn = "N";
                    globalTooltip.rgnId = 'global';
                    globalTooltip.rgnNm = this.$t('COMMON.REGION.global');
                    globalTooltip.plcyCnt = this.getPolicyCount(param);
                    globalTooltip.ruleCnt = this.getRuleCount(param);
                    globalTooltip.failCnt = this.getFailCount(param);
                    globalTooltip.sucsCnt = this.getPassCount(param);
                    if (globalTooltip.ruleCnt == globalTooltip.sucsCnt) {
                        globalTooltip.pass = true;
                    }
                }
            }

            this.setOfMapTooltip(globalTooltip);
            this.initView();
        },
        getPolicyCount: function (param) { // 전체 정책 수
            return this.failPassResultList.plcyMap[param] ? this.failPassResultList.plcyMap[param].length : 0;
        },
        getRuleCount: function (param) { // 정책에 속한 규칙 수
            return this.failPassResultList.ruleMap[param] ? this.failPassResultList.ruleMap[param].length : 0;
        },
        getFailCount: function (param) { // 실패한 규칙
            var count = 0;
            if (this.failPassResultList.failRgnMap[param]) {
                count = this.failPassResultList.failRgnMap[param];
            }
            return count;
        },
        getPassCount: function (param) { // 성공한 규칙
            var count = 0;
            if (this.failPassResultList.passRgnMap[param]) {
                count = this.failPassResultList.passRgnMap[param];
            }
            return count;
        },
        initView() {
            // Themes begin
            am4core.useTheme(am4themes_animated);
            // Themes end

            // Create map instance
            this.chartMap = am4core.create("chartdivMap", am4maps.MapChart);

            // Set map definition
            this.chartMap.geodata = am4geodata_worldLow;

            // Set projection
            this.chartMap.projection = new am4maps.projections.Miller();

            // Create map polygon series
            var polygonSeries = this.chartMap.series.push(new am4maps.MapPolygonSeries());

            // Exclude Antartica
            polygonSeries.exclude = ["AQ"];


            // Make map load polygon (like country names) data from GeoJSON
            polygonSeries.useGeodata = true;

            polygonSeries.tooltip.disabled = true;

            // Configure series
            var polygonTemplate = polygonSeries.mapPolygons.template;
            polygonTemplate.tooltipText = "{name}";
            polygonTemplate.fill = am4core.color('#F6F7F8');
            polygonTemplate.showSystemTooltip = false;


            // Create hover state and set alternative fill color
            // var hs = polygonTemplate.states.create("hover");
            // hs.properties.fill = chartMap.colors.getIndex(0);

            // Add image series
            this.imageSeriesMap = this.chartMap.series.push(new am4maps.MapImageSeries());
            // chartData의 parameter랑 맞춰줘야함(marker에서 사용)
            this.imageSeriesMap.mapImages.template.propertyFields.longitude = "longitude";  // longitude : 경도, - 서경
            this.imageSeriesMap.mapImages.template.propertyFields.latitude = "latitude"; // latitue : 위도, + 북위
            this.imageSeriesMap.mapImages.template.propertyFields.rgnNm = "rgnNm";
            this.imageSeriesMap.mapImages.template.propertyFields.rgnId = "rgnId";
            this.imageSeriesMap.mapImages.template.propertyFields.plcyCnt = "plcyCnt";
            this.imageSeriesMap.mapImages.template.propertyFields.ruleCnt = "ruleCnt";
            this.imageSeriesMap.mapImages.template.propertyFields.failCnt = "failCnt";
            this.imageSeriesMap.mapImages.template.propertyFields.sucsCnt = "sucsCnt";

            this.imageSeriesMap.data = this.chartData;

            let self = this;
            setTimeout(function () {
                self.updateCustomMarkers();
            }, 10)
            // add events to recalculate map position when the map is moved or zoomed

            this.chartMap.events.on("mappositionchanged", function () {
                self.updateCustomMarkers();
            });

        },
        // this function will take current images on the map and create HTML elements for them
        updateCustomMarkers() {
            let self = this;


            // go through all of the images
            let list = this.imageSeriesMap.mapImages._values;
            list.forEach(function (image) {
                // check if it has corresponding HTML element
                if (!image.dummyData || !image.dummyData.externalElement) {
                    // create onex
                    image.dummyData = {
                        externalElement: self.createCustomMarker(image)
                    };
                }

                // reposition the element accoridng to coordinates
                var xy = self.chartMap.geoPointToSVG({longitude: image.longitude, latitude: image.latitude});
                image.dummyData.externalElement.style.top = xy.y + 'px';
                image.dummyData.externalElement.style.left = xy.x + 'px';
            });

        },
        setOfMapTooltip(globalTooltip) {
            let rgnNm = this.$t('COMMON.REGION.' + globalTooltip.rgnId);
            let plcyCnt = globalTooltip.plcyCnt;
            let ruleCnt = globalTooltip.ruleCnt;
            let failCnt = globalTooltip.failCnt;
            let sucsCnt = globalTooltip.sucsCnt;

            const holder = document.getElementById('global-marker');

            const child = document.getElementById('global-map-tooltip');
            if (child) {
                holder.removeChild(child);
            }

            const toolTipWrapper = this.setOfDom(holder, 'global-map-tooltip', rgnNm, plcyCnt, ruleCnt, failCnt, sucsCnt);
            holder.appendChild(toolTipWrapper);

            let marker = holder.getElementsByClassName('marker');
            $(marker).attr('data-state', failCnt > 0 ? 'fail' : 'pass');
        },
        setOfDom(holder, tooltipId, rgnNm, plcyCnt, ruleCnt, failCnt, sucsCnt) {
            const toolTipWrapper = document.createElement('div');
            const toolTipHeader = document.createElement('h2');

            const toolTipHeaderText = document.createTextNode(rgnNm);

            toolTipHeader.appendChild(toolTipHeaderText)

            toolTipWrapper.className = 'map-tooltip-wrap';
            if (tooltipId != null) {
                toolTipWrapper.id = tooltipId;
            }

            const toolTipListWrapper = document.createElement('dl');

            const toolTipListHead = document.createElement('dt');
            const toolTipListHeadText = document.createTextNode(this.$t('DASHBOARD.REGION.HEADER.NUMBER_OF_POLICIES'));
            const toolTipListNum = document.createElement('dd');
            const toolTipListNumText = document.createTextNode(plcyCnt);
            toolTipListHead.appendChild(toolTipListHeadText);
            toolTipListNum.appendChild(toolTipListNumText);

            const toolTipListHead02 = document.createElement('dt');
            const toolTipListHeadText02 = document.createTextNode(this.$t('DASHBOARD.REGION.HEADER.NUMBER_OF_RULES'));
            const toolTipListNum02 = document.createElement('dd');
            const toolTipListNumText02 = document.createTextNode(ruleCnt);
            toolTipListHead02.appendChild(toolTipListHeadText02);
            toolTipListNum02.appendChild(toolTipListNumText02);

            const toolTipListHead03 = document.createElement('dt');
            const toolTipListHeadText03 = document.createTextNode(this.$t('LABEL.FAILED_RULES'));
            const toolTipListNum03 = document.createElement('dd');
            const toolTipListNumText03 = document.createTextNode(failCnt);
            toolTipListHead03.appendChild(toolTipListHeadText03);
            toolTipListNum03.appendChild(toolTipListNumText03);

            const toolTipListHead04 = document.createElement('dt');
            const toolTipListHeadText04 = document.createTextNode(this.$t('LABEL.PASSED_RULES'));
            const toolTipListNum04 = document.createElement('dd');
            const toolTipListNumText04 = document.createTextNode(sucsCnt);
            toolTipListHead04.appendChild(toolTipListHeadText04);
            toolTipListNum04.appendChild(toolTipListNumText04);

            toolTipListWrapper.className = 'map-tooltip-list';

            toolTipListWrapper.appendChild(toolTipListHead);
            toolTipListWrapper.appendChild(toolTipListNum);
            toolTipListWrapper.appendChild(toolTipListHead02);
            toolTipListWrapper.appendChild(toolTipListNum02);
            toolTipListWrapper.appendChild(toolTipListHead03);
            toolTipListWrapper.appendChild(toolTipListNum03);
            toolTipListWrapper.appendChild(toolTipListHead04);
            toolTipListWrapper.appendChild(toolTipListNum04);


            toolTipWrapper.appendChild(toolTipHeader);
            toolTipWrapper.appendChild(toolTipListWrapper);

            return toolTipWrapper;
        },
        // this function creates and returns a new marker element
        createCustomMarker(image) {
            let rgnNm = this.$t('COMMON.REGION.' + image.rgnId);
            let plcyCnt = image.plcyCnt;
            let ruleCnt = image.ruleCnt;
            let failCnt = image.failCnt;
            let sucsCnt = image.sucsCnt;

            // create holder
            const holder = document.createElement('div');
            holder.className = 'map-marker';
            holder.title = image.dataItem.dataContext.rgnNm;
            holder.style.position = 'absolute';

            // maybe add a link to it?
            if (undefined != image.url) {
                holder.onclick = function () {
                    window.location.href = image.url;
                };
                holder.className += ' map-clickable';
            }

            // create dot ( global marker html 참고)

            const dot = document.createElement('div');
            const pulse = document.createElement('div');

            const toolTipWrapper = this.setOfDom(holder, null, rgnNm, plcyCnt, ruleCnt, failCnt, sucsCnt);

            // dot color 지정
            if (image.ruleCnt == image.sucsCnt) {
                pulse.className = 'am-pulse-pass';
                holder.appendChild(pulse);
                holder.appendChild(toolTipWrapper);
            } else {
                dot.className = 'am-dot';
                holder.appendChild(dot);
                pulse.className = 'am-pulse';
                holder.appendChild(pulse);
                holder.appendChild(toolTipWrapper);

            }

            // append the marker to the map container
            this.chartMap.svgContainer.htmlElement.appendChild(holder);

            return holder;
        },
        changeType(type) {
            this.selTab = type;
        },
    }

}
</script>

<style>

#chartdivMap {
    width: 100%;
    height: 300px;
    overflow: hidden;
    position: relative;
}

div#global-marker:hover .map-tooltip-wrap {
    display: contents;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboardRegion.vue